// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"funnelHeader_dropdown_3H3sKe4","dropdownTrigger":"funnelHeader_dropdownTrigger_2fA-jbG","dropdownIcon":"funnelHeader_dropdownIcon_2sfcjxI"};